import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Error } from '../../ui'
import { Section } from './Contact'

export const Legal = () =>
  <>
    <Helmet>
      <title>LFH - Legal Stuff</title>
    </Helmet>
    <div className="darkside about">
      <h1 className="mar-t-none mar-b">Legal stuff</h1>
      <Section icon="gavel" title="Lenses for Hire Ltd." className="mar-t-2">
        <p>
          Registered in England and Wales, number <b>06424657</b>.<br/>
          VAT registration number <b>GB 922 0217 71</b>
        </p>
        <p className="mar-b">
          Registered office:
        </p>
        <address>
          Union House<br/>
          111 New Union Street<br/>
          Coventry<br/>
          CV1 2NT
        </address>
        <Error title="IMPORTANT" className="mar-t-4">
          <p className="mar-t-none largish">
            Do <b className="red">NOT</b> send lenses here.
            This is our registered office <b className="red">NOT</b> our trading address.
          </p>
          <p>
            Please <b className="red">DO NOT</b> write to us or send stuff to us at this address,
            unless you are HMRC or Companies House.  There is nothing at this address
            apart from a little official-looking brass plaque and a man who forwards
            official mail from HMRC and Companies House to us.
          </p>
          <p>
            <b className="red">DO NOT</b> send lenses or other equipment to this address.  There are
            no facilities for handling parcels, so they will be rejected and go into
            some sort of Royal Mail unwanted-parcels limbo from which they will take
            weeks to emerge.  At the end of that we'll have to discuss with you several
            weeks' worth of late fees which, could run into hundreds of pounds, and it
            will all be very awkward.
          </p>
        </Error>
      </Section>
    </div>
  </>

export default Legal